import {
  GET_TRANSFER_TYPE_DROPDOWN,
  SET_TRANSFER_TYPE_DROPDOWN,
  GET_DIVISION_DROPDOWN,
  SET_DIVISION_DROPDOWN,
  GET_COSTCENTER_DROPDOWN,
  SET_COSTCENTER_DROPDOWN,
  SET_ASSET_INFO_STEPPER_DATA
} from "./types";

const getTransferTypeDropdown = () => {
  return {
    type: GET_TRANSFER_TYPE_DROPDOWN,
  };
};

const setTransferTypeDropdown = (value: any) => {
  return {
    type: SET_TRANSFER_TYPE_DROPDOWN,
    payload: value,
  };
};

const getDivisionDropdown = () => {
  return {
    type: GET_DIVISION_DROPDOWN,
  };
};

const setDivisionDropdown = (value: any) => {
  return {
    type: SET_DIVISION_DROPDOWN,
    payload: value,
  };
};

const getCostCenterDropdown = () => {
  return {
    type: GET_COSTCENTER_DROPDOWN,
  };
};

const setCostCenterDropdown = (value: any) => {
  return {
    type: SET_COSTCENTER_DROPDOWN,
    payload: value,
  };
};
const setAssetStepperDataData = (data: any) => {
  return {
    type: SET_ASSET_INFO_STEPPER_DATA,
    payload: data,
  };
};
export {
  getTransferTypeDropdown,
  setTransferTypeDropdown,
  getDivisionDropdown,
  setDivisionDropdown,
  getCostCenterDropdown,
  setCostCenterDropdown,
  setAssetStepperDataData
};
